import { render, staticRenderFns } from "./PersonSearchProfileHeader.vue?vue&type=template&id=08ba8cf4&scoped=true&"
import script from "./PersonSearchProfileHeader.vue?vue&type=script&lang=js&"
export * from "./PersonSearchProfileHeader.vue?vue&type=script&lang=js&"
import style0 from "./PersonSearchProfileHeader.vue?vue&type=style&index=0&id=08ba8cf4&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08ba8cf4",
  null
  
)

export default component.exports